__turbopack_context__.v({
  "canvasEmbed": "Lg556W_canvasEmbed",
  "canvasTitleSection": "Lg556W_canvasTitleSection",
  "ctaBanner": "Lg556W_ctaBanner",
  "faqItem": "Lg556W_faqItem",
  "faqItemIcon": "Lg556W_faqItemIcon",
  "faqItemSummary": "Lg556W_faqItemSummary",
  "faqs": "Lg556W_faqs",
  "hiddenOnMobile": "Lg556W_hiddenOnMobile",
  "layout": "Lg556W_layout",
  "mainContent": "Lg556W_mainContent",
  "page": "Lg556W_page",
  "relatedTemplates": "Lg556W_relatedTemplates",
  "sidebar": "Lg556W_sidebar",
  "title": "Lg556W_title",
});
